import { scaffoldList } from "../../../common/scaffolding/reducers/scaffoldList";
import { MembershipLevelSummary } from "../types";
import { TypeKeys as EditTypeKeys } from "./edit";

enum TypeKeys {
    LOADING = "MEMBERSHIPLEVEL/LIST_BEGIN",
    LOADED = "MEMBERSHIPLEVEL/LIST_SUCCESS",
    FAILED = "MEMBERSHIPLEVEL/LIST_FAILURE",
    RELOAD = "MEMBERSHIPLEVEL/LIST_RELOAD",
}
const list = scaffoldList<MembershipLevelSummary, typeof TypeKeys, typeof EditTypeKeys>(TypeKeys, EditTypeKeys);
const { createAction, reducer } = list;

export type State = ReturnType<typeof list.reducer>;
export { createAction, reducer };
